document.addEventListener("DOMContentLoaded", function() {
  const sliders12 = document.querySelectorAll(".before_after_slider");

  sliders12.forEach(slider => {
    const section = slider.closest(".before_after_main");
    const frontImage = section.querySelector(".after_front_img");
    const lineAfterSpan = section.querySelector("#line_after"); // Get the span element

    frontImage.style.clipPath = `polygon(0 0, ${slider.value}% 0, ${slider.value}% 100%, 0% 100%)`;
    lineAfterSpan.style.left = `${slider.value - 3.2}%`;

    slider.addEventListener("input", function () {
      frontImage.style.clipPath = `polygon(0 0, ${this.value}% 0, ${this.value}% 100%, 0% 100%)`;
      lineAfterSpan.style.left = `${this.value - 3.2}%`;
    });
  });
});

// scroll smooth 

$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});


// before-after

if($('.before-after-slider').length){
const slider = document.getElementById('before-after-slider');
  const before = document.getElementById('before-image');
  const beforeImage = before.getElementsByTagName('img')[0];
  const resizer = document.getElementById('resizer');
  let active = false;
  document.addEventListener("DOMContentLoaded", function() {
    let width = slider.offsetWidth;
    console.log(width);
    beforeImage.style.width = width + 'px';
  });
  window.addEventListener('resize', function() {
    let width = slider.offsetWidth;
    console.log(width);
    beforeImage.style.width = width + 'px';
  })
  resizer.addEventListener('mousedown',function(){
    active = true;
   resizer.classList.add('resize');
  });
  document.body.addEventListener('mouseup',function(){
    active = false;
   resizer.classList.remove('resize');
  });
  document.body.addEventListener('mouseleave', function() {
    active = false;
    resizer.classList.remove('resize');
  });
  document.body.addEventListener('mousemove',function(e){
    if (!active) return;
    let x = e.pageX;
    x -= slider.getBoundingClientRect().left;
    slideIt(x);
    pauseEvent(e);
  });
  resizer.addEventListener('touchstart',function(){
    active = true;
    resizer.classList.add('resize');
  });
  document.body.addEventListener('touchend',function(){
    active = false;
    resizer.classList.remove('resize');
  });
  document.body.addEventListener('touchcancel',function(){
    active = false;
    resizer.classList.remove('resize');
  });
  document.body.addEventListener('touchmove',function(e){
    if (!active) return;
    let x;
    let i;
    for (i=0; i < e.changedTouches.length; i++) {
    x = e.changedTouches[i].pageX; 
    }
    x -= slider.getBoundingClientRect().left;
    slideIt(x);
    pauseEvent(e);
  });
  function slideIt(x){
      let transform = Math.max(0,(Math.min(x,slider.offsetWidth)));
      before.style.width = transform+"px";
      resizer.style.left = transform-0+"px";
  }
  function pauseEvent(e){
      if(e.stopPropagation) e.stopPropagation();
      if(e.preventDefault) e.preventDefault();
      e.cancelBubble=true;
      e.returnValue=false;
      return false;
  }
}
